module.exports = __webpack_public_path__ + "img/eae4967.jpg";